module.exports = __webpack_public_path__ + "static/media/ad-notification-textlink-mockup-below.5f62d470.png";